import React from "react";
import {
  withStyles,
  Table,
  TableCell,
  TableRow,
  TableBody,
} from "@material-ui/core";
import styles from "./recommendationStyles";
import { utcToZonedTime } from "date-fns-tz";
import appConstants from "../../../../../appConstants";
import { format } from "date-fns";

const getEstimatedMilesRemaining = ({
  estimatedMilesRemaining,
  estimatedIncreaseInMiles = 0,
}) => {
  let increaseInMiles = Math.round(estimatedIncreaseInMiles);
  const sign = increaseInMiles > 0 ? "+" : "-";
  if (increaseInMiles) {
    increaseInMiles = `(${sign}${Math.abs(increaseInMiles)})`;
  }
  return `${Math.round(estimatedMilesRemaining)} ${increaseInMiles || ""}`;
};

const getEstimatedTravelTime = ({
  estimatedTravelTimeRemaining,
  estimatedIncreaseInTravelTime,
}) => {
  const sign = estimatedIncreaseInTravelTime > 0 ? "+" : "-";
  if (estimatedIncreaseInTravelTime) {
    estimatedIncreaseInTravelTime = `(${sign}${Math.abs(
      estimatedIncreaseInTravelTime
    )})`;
  }
  return `${estimatedTravelTimeRemaining} ${
    estimatedIncreaseInTravelTime || ""
  }`;
};

const DetailsTable = ({ classes, data, terminalOffset }) => {
  const arrivalTime = format(
    utcToZonedTime(data.arrivalTime, terminalOffset),
    appConstants.DATETYPES.TIME.format
  );

  const estimatedMilesRemainingText = getEstimatedMilesRemaining(data);
  const estimatedTravelTime = getEstimatedTravelTime(data);
  return (
    <Table size="small">
      <TableBody>
        <TableRow className={classes.tableRow}>
          <TableCell className={classes.tableHeaderCell}>
            Proj. Trailer Space
          </TableCell>
          <TableCell className={classes.tableHeaderCell}>Arrival</TableCell>
          <TableCell className={classes.tableHeaderCell}>Total Miles</TableCell>
          <TableCell className={classes.tableHeaderCell}>Total Time</TableCell>
          <TableCell className={classes.tableHeaderCell} align="right">
            Missed Stops
          </TableCell>
        </TableRow>
        <TableRow className={classes.tableRow}>
          <TableCell className={classes.enrouteTo}>
            {`${parseFloat(data.trailerCapacity?.toFixed(2))} Pallets left`}
          </TableCell>
          <TableCell className={classes.tableDataCell}>{arrivalTime}</TableCell>
          <TableCell className={classes.tableDataCell}>
            {estimatedMilesRemainingText}
          </TableCell>
          <TableCell className={classes.tableDataCell}>
            {estimatedTravelTime}
          </TableCell>
          <TableCell
            className={`${classes.tableDataCell} ${
              data.numServiceViolations > 0 ? classes.missedStops : ""
            }`}
            align="right"
          >
            {data.numServiceViolations}
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
};

export default withStyles(styles)(DetailsTable);
